export default "__VITE_ASSET__CucBPqvu__"